import { jsx as n } from "react/jsx-runtime";
import { createContext as i, useContext as s } from "react";
var a = /* @__PURE__ */ ((t) => (t.light = "light", t.dark = "dark", t))(a || {});
const e = i(
  "light"
  /* light */
), h = () => s(e), l = (t) => {
  const { value: r, children: o } = t;
  return /* @__PURE__ */ n(e.Provider, { value: r, children: o });
};
export {
  a as ThemeEnum,
  l as default,
  h as useTheme
};
